<div class="c-skills -category" [id]="elementId">
	<h2>{{ title }}</h2>
	@for (competence of competences; track competence; let i = $index) {
		<div>
			<occupational-profile-competence-item [index]="i" [competence]="competence"></occupational-profile-competence-item>
		</div>
	}
	@if (competences) {
		@for (competence of restCompetences; track competence; let i = $index) {
			<div class="extraCompetences">
				<occupational-profile-competence-item [index]="i + competences.length" [competence]="competence"></occupational-profile-competence-item>
			</div>
		}
	}

	@if (hasRestCompetences()) {
		<div id="occupational-profile-competence-show-more" class="c-skills__show-extra" (click)="toggleAllCompetences($event)">
			<a [ngClass]="showAllCompetences ? 'action-hide' : 'action-show'">{{ showAllCompetences ? 'Toon minder' : 'Toon meer' }}</a>
		</div>
	}
</div>

